import React, { Fragment } from 'react';

function OfferedSectionHeaderRow(props) {
  const {
    recipeCategoryId,
    collapsed,
    offeredTotalByRecCat,
    offeredAdultTotalByRecCat,
    offeredAlacarteTotalByRecCat,
    offeredPreKTotalByRecCat,
  } = props;
  
  const offeredReimbursableTotal = offeredTotalByRecCat[recipeCategoryId];
  const offeredAdultTotal = offeredAdultTotalByRecCat[recipeCategoryId];
  const offeredAlacarteTotal = offeredAlacarteTotalByRecCat[recipeCategoryId];
  const offeredTotal = offeredAdultTotal + offeredReimbursableTotal + offeredAlacarteTotal;
  const offeredPreKTotal = offeredPreKTotalByRecCat[recipeCategoryId];
  
  return (
    <Fragment>
      <div className="grid-item blue">{offeredReimbursableTotal}</div>
      {!collapsed && (
        <Fragment>
          <div className="grid-item blue">{offeredPreKTotal}</div>
          <div className="grid-item blue">{offeredAlacarteTotal}</div>
          <div className="grid-item blue">{offeredAdultTotal}</div>
          <div className="grid-item blue">{offeredTotal}</div>
        </Fragment>
      )}
    </Fragment>
  );
}

const MemoizedOfferedSectionHeaderRow = React.memo(OfferedSectionHeaderRow);

export { MemoizedOfferedSectionHeaderRow as OfferedSectionHeaderRow };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/OfferedSectionHeaderRow.js